// eslint-disable-next-line jira/filename-case
import React from 'react';
import { useGetCurrentUrl } from '@jira/navigation-apps__routing-hooks/src/useGetCurrentUrl.tsx';
import AlignTextLeftIcon from '@atlaskit/icon/core/align-text-left';
import {
	type FlyoutMenuItemTriggerProps,
	FlyoutMenuItem,
	FlyoutMenuItemTrigger,
	FlyoutMenuItemContent,
} from '@atlaskit/side-nav-items/flyout-menu-item';

import { JiraEntryPointContainer } from '@jira/platform__entry-points-container/src/index.tsx';
// eslint-disable-next-line jira/restricted/@atlassian+jira-entry-point
// eslint-disable-next-line jira/restricted/@atlassian+jira-entry-point
// eslint-disable-next-line jira/restricted/@atlassian+jira-entry-point
import { useEntryPoint } from '@jira/platform__entry-point/src/controllers/use-entry-point/index.tsx';
import { useEntryPointButtonTrigger } from '@jira/platform__entry-point-button-trigger/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { SkeletonNavMenuItems } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/ui/skeleton-nav-menu-items/main.tsx';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { MoreProjectsEntrypoint } from '../content/MoreProjectsEntrypoint.entrypoint.tsx';
import { PACKAGE_NAME, TEAM_NAME } from '../../constants.tsx';

type Props = Omit<FlyoutMenuItemTriggerProps, 'elemBefore'>;

export function MoreProjectsFlyout(props: Props): React.JSX.Element {
	const cloudId = useCloudId();
	const currentURL = useGetCurrentUrl();

	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(MoreProjectsEntrypoint, {
		cloudId,
		currentURL,
	});

	const triggerRef = useEntryPointButtonTrigger(entryPointActions);

	return (
		<FlyoutMenuItem>
			<FlyoutMenuItemTrigger
				{...props}
				ref={triggerRef}
				elemBefore={<AlignTextLeftIcon label="" color="currentColor" />}
			/>
			<FlyoutMenuItemContent
				maxHeight={fg('platform_dst_nav4_flyout_menu_slots_close_button') ? 460 : undefined}
			>
				<JiraEntryPointContainer
					entryPointReferenceSubject={entryPointReferenceSubject}
					id="sidebar-nav4-more-projects-flyout"
					packageName={PACKAGE_NAME}
					teamName={TEAM_NAME}
					errorFallback="flag"
					fallback={<SkeletonNavMenuItems withSearch withSubHeading isFlyout count={10} />}
					runtimeProps={{}}
				/>
			</FlyoutMenuItemContent>
		</FlyoutMenuItem>
	);
}
